export interface CategoriaCliente extends DenominableEntity {
  codigo?: string
}

export const CATEGORIA_CLIENTE_OPTIONS_KEY = 'CATEGORIA_CLIENTE_OPTIONS'
